import React from 'react';

import { normalizeHexCode } from '~/styles/utils';

interface PlansIconProps {
  name: string;
  title: string;
  replaceWithText?: string | null;
  textClasses?: string;
  redesign20?: boolean;
  iconColor?: string;
  iconClasses?: string;
}

export enum plansEnum {
  CORE = 'Core',
  MAX = 'Max',
  INFINITY = 'Infinity',
  INVEST = 'Greenlight + Invest'
}

export const getRewardByPlan = (name: string) => {
  switch (name) {
    case plansEnum.MAX:
      return 2;

    case plansEnum.INFINITY:
      return 5;

    case plansEnum.CORE:
    default:
      return 1;
  }
};

export default function PlansIcon({
  name,
  title,
  replaceWithText,
  textClasses = 'text-base font-medium text-[#1D252C] max-w-[200px]',
  iconColor = '',
  iconClasses = ''
}: PlansIconProps) {
  const titleId = React.useId();
  if (replaceWithText) {
    return (
      <h3 className={textClasses} data-testid={`${name}-plan-text`}>
        {replaceWithText}
      </h3>
    );
  } else {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="25"
        height="25"
        viewBox="0 0 25 25"
        fill={normalizeHexCode(iconColor)}
        data-testid={`${name}-${title}`}
        className={`${iconClasses}`}
        aria-labelledby={titleId}
      >
        <title id={titleId}>{`${title} included in ${name}`}</title>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M1.625 12.5791C1.625 6.5141 6.56 1.5791 12.625 1.5791C18.69 1.5791 23.625 6.5141 23.625 12.5791C23.625 18.6441 18.69 23.5791 12.625 23.5791C6.56 23.5791 1.625 18.6441 1.625 12.5791ZM7.125 12.8502L12.1433 17.0791L18.125 9.80548L15.6673 8.0791L11.7286 12.8683L9.205 10.7414L7.125 12.8502Z"
          fill={normalizeHexCode(iconColor)}
        />
      </svg>
    );
  }
}
